import { ModuleHeaderSlot, SearchField } from "@tm/components"
import { useState } from "react"
import { useLocalization } from "@tm/localization"
import { useFavoriteArticlesStore } from "../store"
import { AddNewListButton } from "../ModuleHeader/AddNewListButton"

export function Options() {
    const { translateText } = useLocalization()
    const { query, setQuery } = useFavoriteArticlesStore()

    const [searchText, setSearchText] = useState(query ?? "")

    function handleStartSearch() {
        setQuery(searchText)
    }

    function handleClearSearch() {
        setQuery("")
    }

    return (
        <>
            <ModuleHeaderSlot title={translateText(177)}>
                <AddNewListButton />
            </ModuleHeaderSlot>
            <ModuleHeaderSlot title={translateText(135)}>
                <SearchField
                    id="compilationsSearch"
                    value={searchText}
                    onChange={setSearchText}
                    onStartSearch={handleStartSearch}
                    onClear={handleClearSearch}
                    placeholder={translateText(1770)}
                    inputProps={{ maxLength: 100 }}
                />
            </ModuleHeaderSlot>
        </>
    )
}
